var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ExhibitorForm',{attrs:{"type":'edit',"save-action":_vm.updateItemAction,"back":_vm.back,"error":_vm.error,"saved":_vm.updated,"loading":_vm.loading,"item":_vm.item,"profile-update":_vm.profileUpdate,"reset-action":_vm.resetAction,"is-exhibitor":_vm.isExhibitor}})
}
var staticRenderFns = []

export { render, staticRenderFns }